<app-content-management [cmsName]="'Terms & Conditions'" [pageName]="'terms-condition'"></app-content-management>